import axios from '@/api/axios'
import { resourceConstructor } from '@/api'
import { getFingerprint } from '@/utils/fingerprint'

const constructFullUrl = resourceConstructor('user')

export default {
  login: async ({ data } = {}) =>
    axios.post(constructFullUrl('auth/login'), data, {
      headers: {
        'device-id': await getFingerprint(),
        platform: 'suraasa-web',
      },
    }),

  generatePlatformToken: async ({ data } = {}) =>
    axios.post('/solis/v1/auth/user-tokens/', data),

  logout: data => axios.post('/solis/v1/auth/logout/', data),

  resetPassword: data =>
    axios.post(constructFullUrl('auth/reset-password'), data),

  setPassword: data =>
    axios.post(constructFullUrl('auth/reset-password/confirm'), data),

  listProfessors: ({ params } = {}) =>
    axios.get(constructFullUrl('professors'), { params }),

  listStudents: ({ params } = {}) =>
    axios.get(constructFullUrl(''), { params }),
}
